<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required, email } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from "@/i18n";
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { USER_MODULE } from '@/state/modules/user'
import { lookupMethods, userMethods } from "@/state/helpers";

// const checkFalse = (value) => value != false;

export default {
  page: {
    title: i18n.t("label.createX", [i18n.t("module.user")]),
  },
  components: { Layout, PageHeader },
  beforeRouteLeave(to, from, next) {
    if (to.name != "User-listing") {
      sessionHelper.clearSearch(SESSION.USER_SEARCH);
    }
    next();
  },
  computed: {
    ...mapState(USER_MODULE, ["status"]),
    ...mapState(LOOKUP_MODULE),
    roleDdl() {
      return this.$store.state.lookup.roleDdl;
    },
  },
  data() {
    return {
      title: i18n.t("label.createX", [i18n.t("module.user")]),
      items: [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.user"),
          href: "/user",
        },
        {
          text: i18n.t("label.createX", [i18n.t("module.user")]),
          active: true,
        },
      ],
      submitted: false,
      statusDdl: ddlHelper.getActivationStatus(false, true),
      permissions: sessionHelper.getPermissions(),
      createPermission: null,
      createForm: {
        name: "",
        email: "",
      },
    };
  },
  validations: {
    createForm: {
      name: { required },
      email: { required, email },
      roleId: { required }
    },
  },
  async created() {
    await this.validPermissions();
    this.lookupRole({ hasOptionAll: false });
  },
  methods: {
    ...userMethods,
    ...lookupMethods,
    async validPermissions() {
      var jsonPermissions = JSON.parse(this.permissions)
      if (jsonPermissions.some(p => p.code === "USER_UC")) {
        this.createPermission = true;
      }
      else {
        this.createPermission = false;
      }
    },
    requestCreate() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        let data = {
          name: this.createForm.name,
          email: this.createForm.email,
          roleId: this.createForm.roleId,
        };

        if (this.createPermission == true) {
          this.createUser({ data });
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="requestCreate" v-if="createPermission == true">
              <b-form-group id="name" label-cols-sm="2" label-cols-lg="2" :label="$t('label.name')" label-for="name">
                <b-form-input for="name" v-model.trim="createForm.name" :class="{
                  'is-invalid': submitted &&
                    !$v.createForm.name.required
                }"></b-form-input>
                <div v-if="submitted &&
                  !$v.createForm.name.required" class="invalid-feedback">
                  <span v-if="!$v.createForm.name.required">{{
                    $t("message.requiredX", [$t("label.name")])
                  }}</span>
                </div>
              </b-form-group>

              <b-form-group id="email" label-cols-sm="2" label-cols-lg="2" :label="$t('label.email')" label-for="email">
                <b-form-input id="email" v-model.trim="createForm.email" :class="{
                  'is-invalid':
                    submitted &&
                    (!$v.createForm.email.required ||
                      !$v.createForm.email.email),
                }"></b-form-input>
                <div v-if="submitted &&
                  (!$v.createForm.email.required ||
                    !$v.createForm.email.email)
                " class="invalid-feedback">
                  <span v-if="!$v.createForm.email.required">{{
                    $t("message.requiredX", [$t("label.email")])
                  }}</span>
                  <span v-if="!$v.createForm.email.email">{{
                    $t("message.validX", [$t("label.email")])
                  }}</span>
                </div>
              </b-form-group>

              <div class="form-group row mb-0">
                <label class="col-md-2 col-form-label">{{ $t("module.role") }}</label>

                <div class="row">
                  <div class="col-sm-5 py-2" v-for="role in roleDdl" v-bind:key="role.value">
                    <div class="form-check">
                      <b-form-checkbox type="checkbox" v-model="createForm.roleId" v-bind:value="role.value"
                        v-bind:id="role.value" :stacked="roleDdl.length > 3">
                        {{ role.text }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
                <div v-if="!$v.createForm.roleId.required" style="color: #ff3d60; font-size: 80%">
                  <span v-if="submitted && !$v.createForm.roleId.required">{{
                    $t("message.atLeastOneSelectedX", [$t("label.permission")])
                  }}</span>
                </div>
              </div>

              <div class="mt-4 text-center" style="float: right">
                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px" type="submit"
                  :disabled="status.processing">
                  {{ $t("label.createX", [$t("module.user")]) }}
                </button>
              </div>
            </form>
            <div style="text-align: center;" v-else>
              {{ $t('message.noPermissionMessage') }}
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>